import { Injectable } from '@angular/core';
import {ServerProvider} from '../server/server';
import 'rxjs/add/operator/map';


@Injectable()
export class LocalStorageServiceProvider {
    server_cli : ServerProvider;

    constructor(public server: ServerProvider) {
        this.server_cli = server;
    }

    setCategories(categories) {
        window.localStorage.setItem('categories', JSON.stringify(categories))
    }

    getCategories() {
        return JSON.parse(window.localStorage.getItem('categories'))
    }

    fetchCategories(){
        console.log("Fetching categories")
        this.server_cli.getCategories().subscribe(
            response=>{
                this.setCategories(response.json())
                console.log(response.text)
                console.log("Categories fetched from server...")
            },
            error=>{
                console.log("Failed to fetch categories...")
            }
        )
    }


}



// WEBPACK FOOTER //
// ./src/providers/local-storage-service/local-storage-service.ts